import {
  SET_PROPERTY_LOADING,
  UPDATE_SEARCH_COLUMN,
  UPDATE_PROPERTY_SIX_PART_FILE,
  GET_PROPERTY,
  SET_PROPERTY_FIELDS,
  REMOVE_PROPERTY_LOADING,
  SET_PROPERTY_OLD_VALUE,
  REMOVE_PROPERTY_OLD_VALUE,
  SET_APP_CODE,
  SET_PROPERTY_ACCESS,
  PROPERTY_UPDATED,
} from "../../types";
import { socket } from "@helpers/bootstrap";
import axios from "axios";
import { setCommission, setPurchasers, updatePurchasers } from "./disposition";
import { setAlert } from "../alert";
import { setFinancialLiens, updateFinancialLiens } from "./liens";
import {
  setPropMInspection,
  setPropMLockboxInfo,
  setPropMRepairMaintenace,
  setPropMViolation,
  setUtilityVendorReference,
  updateManagement,
} from "./management";
import { updateMarketing } from "./marketing";
import { setAmenities, updateAmenities } from "./amenities";
import { setBudgetData, updateBudget } from "./budget";
import { setContacts, updateContacts } from "./contacts";
import { updateEnvironmental, environmentalHook } from "./enviromental";
import { updateAcquisition } from "./acquisition";
import { updateTax } from "./tax";
import { updateTitle, setTitleNotes, removeTitleNotes } from "./title";
import { fetchAssetAssociations, updateAssociations } from "../associations";

import { triggerConfirmModal } from "../modals/confirm";

import { updateValuation } from "./valuation";
import { FDIC_UpdateValuation } from "./FDIC/valuation";
import { FDIC_updateAcquisition } from "./FDIC/acquisition";
import { FDIC_updateManagement } from "./FDIC/management";
import { UserAccess } from "../permissions/permissions";
import { handleResponse } from "../response";
import { handleError } from "../error";

import { CanI } from "../permissions/permissions";

export const reloadPropertyLogRowField =
  ({ propertyId, type, fieldName, verb }) =>
  async (dispatch, getState) => {
    try {
      const response = await axios.get(
        `/properties/edit/${propertyId}/log-rows/${fieldName}/legacy`,
      );
      const nextValue = response?.data?.rows;
      const {
        properties: { propertyFields },
      } = getState();
      await dispatch({
        type: SET_PROPERTY_FIELDS,
        payload: {
          ...propertyFields,
          [fieldName]: JSON.stringify(nextValue),
        },
      });

      switch (fieldName) {
        case "property_management_violations":
          dispatch(setPropMViolation());
          break;
        case "property_management_lockbox_info":
          dispatch(setPropMLockboxInfo());
          break;
        case "property_management_inspections":
          dispatch(setPropMInspection());
          break;
        case "property_management_maintenance_and_repairs":
          dispatch(setPropMRepairMaintenace());
          break;
        case "title_notes":
          dispatch(setTitleNotes());
          break;
        case "purchasers":
          dispatch(setPurchasers());
          break;
        default:
          break;
      }
      return nextValue;
    } catch (error) {
      console.warn("Failed to reload log row field", error);
      throw error;
    }
  };

const checkUserAccess =
  ({ component, verb, phase }) =>
  async (dispatch) => {
    try {
      const isPermitted = await dispatch(UserAccess(component, verb, phase));
      await dispatch({
        type: SET_PROPERTY_ACCESS,
        payload: isPermitted,
      });
    } catch (error) {
      dispatch(error.message, "error");
    }
  };

export const PropertyUpdated =
  ({ status }) =>
  async (dispatch) => {
    try {
      if (status === true) {
        dispatch(
          setAlert(
            "Property was modified. Please reload to continue!",
            "info",
            300000,
          ),
        );
      }
      dispatch({
        type: PROPERTY_UPDATED,
        payload: true,
      });
    } catch (error) {
      dispatch(setAlert(error.message, "error"));
    }
  };

//  Get all Properties' Assets
//  @TODO: Figure out the distribution and spread out the process
//  of setting the property assets
export const getPropertyAssets = () => async (dispatch, getState) => {
  try {
    const {
      properties: {
        propertyFields: { id },
      },
    } = getState();
    dispatch({ type: SET_PROPERTY_LOADING });
    await dispatch(setBudgetData());
    await dispatch(setPurchasers());
    await dispatch(setCommission());
    await dispatch(setFinancialLiens());
    await dispatch(setPropMInspection());
    await dispatch(setPropMLockboxInfo());
    await dispatch(setPropMRepairMaintenace());
    await dispatch(setPropMViolation());
    await dispatch(setUtilityVendorReference());
    await dispatch(setAmenities());
    await dispatch(setContacts());
    await dispatch(setTitleNotes());
    await dispatch(fetchAssetAssociations("properties", id));

    dispatch({ type: REMOVE_PROPERTY_LOADING });
  } catch (error) {
    dispatch(setAlert("Get Assets Failed " + error.message, "error"));
  }
};

/**
 * @name	removePropertyAssets
 * DESC: This method will triger when component is un-mount to remove data from redux state
 */
export const removePropertyAssets = () => async (dispatch) => {
  try {
    await dispatch(removeTitleNotes());
  } catch (error) {
    dispatch(setAlert("Remove Assets Failed " + error.message, "error"));
  }
};

/**
 * @name	getProperty
 * @param 	{*} id
 */
export const getProperty =
  ({ component, verb, componentID }) =>
  async (dispatch) => {
    try {
      dispatch({ type: SET_PROPERTY_LOADING });
      const isPermitted = await dispatch(CanI("properties_" + verb));
      if (!isPermitted) {
        window.location.href = `/${component}/`;
      }

      //	DESC: Getting single property from backend using id
      //	DESC: ReactAPI is a temporary query to differentia from regular view
      //	DESC: Once merge, We'll remove it
      const result = await axios.post(
        `/${component}/${verb}/${componentID}?ReactAPI=true`,
      );

      //  Clone skeleton from response data
      const skeleton = JSON.parse(JSON.stringify(result.data.skeleton));

      //  delete skeleton from response data
      delete result.data.skeleton;

      await dispatch({
        type: GET_PROPERTY,
        payload: result.data,
      });

      dispatch(handleResponse(result));

      //	 DESC: Setting PropertyFields to global state
      await dispatch(setPropertyFields(result.data));
      await dispatch(
        checkUserAccess({
          component,
          verb,
          phase: result.data.property.phase_primary,
        }),
      );

      await dispatch({ type: REMOVE_PROPERTY_LOADING });
      return {
        code: result.data.property.code || result.data.property.code_temp,
        name: result.data.property.name,
        skeleton,
      };
    } catch (error) {
      dispatch(handleError(error));
      return false;
    }
  };

export const setPropertyFields = (data) => async (dispatch) => {
  try {
    //	SetPropertyFields will trigger on first load, This will preset all data before application load
    const { property } = data;
    const { address, city, state, zip } = property;
    const { lot_size, building_size } = property;

    if (lot_size) {
      const sqft_of_an_acre = 43560;
      property.lot_sqft = (parseFloat(lot_size) * sqft_of_an_acre).toFixed(3);
    }

    //	Set building_size to 0 so 5410 - Maintenance and Repairs calculation won't break
    if (!building_size) {
      property.building_size = 0;
    } else {
      property.building_size = parseFloat(building_size).toFixed(4);
    }

    property["full-asset-address"] = `${address} ${city}, ${state} ${zip}`;

    await dispatch({
      type: SET_APP_CODE,
      payload: data.app_code,
    });
    await dispatch({
      type: SET_PROPERTY_FIELDS,
      payload: { ...property },
    });
    dispatch(getPropertyAssets());
  } catch (error) {
    dispatch(handleError(error));
  }
};

/**
 * @name    updatePropertyFields
 * @param   event
 * @param   currentTab
 * @returns {function(...[*]=)}
 * @description
 * This Function Update global property's fields
 * This Function Update global property's fields
 * It will require a tabName if current tab needs special attention
 * Custom component will be require to mock an Event Object
 * Be sure take test custom components carefully
 */

export const updatePropertyFields =
  (event, currentTab) => async (dispatch, getState) => {
    try {
      event.persist();
      //	Cancel change event for these fields because We don't want to update these
      if (event.target.name === "full-asset-address") {
        return;
      }
      const {
        properties: { propertyFields, propertyData },
        MISC: {
          APP: {
            CODE,
            ROUTE: { verb },
          },
        },
      } = getState();

      //	ATTN: for some reason, client_notes can't trigger bootstrap modal; Therefore, I have to set it as cient_note and change it to client_notes when updating date. UPDATE :Found a conflict with tab name
      //	TODO: IDK what is going on so we have to find out somehow.
      let name =
        event.target.name === "client_note"
          ? "client_notes"
          : event.target.name;

      // DESC: TAX - UNDER PROTEST
      const { value, dataset, type, selectedIndex } = event.target;
      // if (dataset && dataset.required != "0") {
      //     const validated = validateField(event);
      //     if (!validated) return;
      // }
      if (value && typeof value === "string" && value.startsWith("=")) {
        throw new Error('"=" is not a valid entry!');
      }
      const { lot_size, lot_sqft } = propertyFields;

      if (name === "lot_size") {
        const sqft_of_an_acre = 43560;
        propertyFields.lot_sqft = (
          parseFloat(lot_size) * sqft_of_an_acre
        ).toFixed(2);
      }

      if (name === "lot_sqft") {
        const sqft_of_an_acre = 43560;
        propertyFields.lot_size = (
          parseFloat(lot_sqft) / sqft_of_an_acre
        ).toFixed(2);
      }

      switch (type) {
        case "select-one": {
          const { financial_settlement_date } = propertyFields;
          //	DESC: Get child name from dataset and get casecade from option's dataset
          const { child } = dataset;
          const { cascade } = event.target.options[selectedIndex].dataset;
          //	DESC: required settlement date to be set before they can set this to inactive.
          if (
            name === "status_primary" &&
            value === "I" &&
            !financial_settlement_date
          ) {
            return dispatch(
              setAlert(
                "In order to set the Asset Status to inactive there must be a settlement date in the system. Please provide a settlement date in the Disposition Tab.",
                "info",
                20000,
              ),
            );
          } else if (name === "status_primary" && value === "Y") {
            if (
              !confirm(
                "Changing status to Active will remove current settlement date. Do you wish to continue?",
              )
            ) {
              return;
            }
          }

          //	DESC: Check if child name is exist - child name name only avalable on some selects not all selects
          if (child) {
            //	DESC: get child select tag using child name
            const childSelect = document.querySelector(`[name="${child}"]`);
            if (!childSelect) {
              break;
            }

            //	DESC: set child select value to empty when parent is changed)
            const dropdown = propertyData[childSelect.dataset.dropdown];

            const disabledSet = new Set();
            dropdown.forEach((option) => {
              if (!cascade?.split(",").includes(option.code)) {
                option.disabled = true;
                disabledSet.add(option.id.toString());
                return;
              }
              option.disabled = false;
            });
            // Check if the propertyFields[childSelect] is a disabled option or not, if it is, set it to an ""
            const isDisabledField = disabledSet.has(
              propertyFields[childSelect.name]?.toString(),
            );
            if (isDisabledField) {
              propertyFields[childSelect.name] = "";
            }

            // Object.values(childSelect).forEach(option => {
            //     if (
            //         option.dataset &&
            //         option.dataset.hasOwnProperty("code") &&
            //         option.value !== ""
            //     ) {
            //         if (
            //             cascade.split(",").includes(option.dataset.code)
            //         ) {
            //             option.disabled = false;
            //             option.style.display = "block";
            //             legit.push(option.dataset.code);
            //         }
            //         else {
            //             if (option.dataset.code !== "NO_SELECT") {
            //                 option.style.display = "none";
            //             }
            //             option.setAttribute("disabled", "disabled");
            //             disabled.push(option.dataset.code);
            //         }
            //     }
            // });

            //	DESC: Check if child of child exist and hide all options
            // let childDropdown = null;
            // if (childSelect.dataset.child) {
            //     const childChildSelect = document.querySelector(
            //         `[name='${childSelect.dataset.child}']`
            //     );
            //     childDropdown = propertyData[childSelect.dataset.dropdown];
            //     childDropdown.forEach(option => {
            //         if (!cascade.split(",").includes(option.code)) {
            //             option.disabled = true;
            //         }
            //     });
            //     propertyFields[childSelect.dataset.child] = "";
            //     childChildSelect &&
            //         Object.values(childChildSelect).forEach(option => {
            //             if (option.dataset && option.value !== "") {
            //                 if (option.dataset.code !== "NO_SELECT") {
            //                     option.style.display = "none";
            //                 }
            //                 option.disabled = true;
            //             }
            //         });
            // }

            await dispatch({
              type: SET_PROPERTY_FIELDS,
              payload: {
                ...propertyFields,
                [event.target.name]: event.target.value,
              },
            });
            await dispatch({
              type: GET_PROPERTY,
              payload: {
                ...propertyData,
                [childSelect.dataset.dropdown]: dropdown,
              },
            });
          }
          break;
        }
        default:
          break;
      }

      if (
        currentTab !== "environmental" &&
        ["type_primary", "type_secondary", "year_built"].includes(
          event.target.name,
        )
      ) {
        if (event.target.name === "year_built" && event.target.value < 1800) {
          // Skip because they may still be typing the year
          // ie 1, 19, 194, -> 1943
          // The first few inputs would trigger env
        } else if (
          parseInt(propertyFields[event.target.name]) ===
          parseInt(event.target.value)
        ) {
          // The value hasn't changed, don't trigger env
        } else {
          dispatch(environmentalHook(event));
        }
      }

      switch (currentTab) {
        case "acquisition":
          if (CODE === "FDIC") {
            dispatch(FDIC_updateAcquisition(event));
          } else {
            dispatch(updateAcquisition(event));
          }
          break;
        case "amenities":
          dispatch(updateAmenities(event));
          break;
        case "budget":
          dispatch(updateBudget(event));
          break;
        case "contacts":
          dispatch(updateContacts(event));
          break;
        case "disposition":
          dispatch(updatePurchasers(event));
          break;
        case "environmental":
          dispatch(updateEnvironmental(event));
          break;
        case "liens":
          await dispatch(updateFinancialLiens(event));
          break;
        case "marketing":
          dispatch(updateMarketing(event));
          break;
        case "property_management":
          if (CODE === "FDIC") {
            dispatch(FDIC_updateManagement(event));
          } else {
            dispatch(updateManagement(event));
          }

          break;
        case "tax":
          dispatch(updateTax(event));
          break;
        case "title": {
          dispatch(updateTitle(event));
          break;
        }
        case "valuation": {
          if (CODE === "FDIC") {
            dispatch(FDIC_UpdateValuation(event));
          } else {
            dispatch(updateValuation(event));
          }
          break;
        }
        case "associations": {
          dispatch(updateAssociations(event));
          break;
        }
        default:
          //  DESC: This default will update fields according to field's name and field's value
          //  DESC: Please create custom case for special cases
          dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: {
              ...propertyFields,
              [name]: event.target.value,
            },
          });
          break;
      }

      if (event.status === "No" || verb === "add") {
        return;
      }

      switch (event.target.name) {
        case "group_code":
        case "task_order":
          await dispatch(
            triggerConfirmModal(
              `Changing the ${dataset.displayName} field will remove all existing file shares. Are you sure you want to proceed?`,
              name,
            ),
          );
          break;
        default:
          break;
      }
    } catch (error) {
      dispatch(setAlert(error.message, "error"));

      return 500;
    }
  };

//	DESC: handle on field focus
export const onFieldFocus = (event) => async (dispatch, getState) => {
  const {
    MISC: {
      APP: {
        ROUTE: { verb },
      },
    },
  } = getState();
  if (verb === "add") {
    return;
  }

  try {
    const {
      properties: { propertyFields },
    } = getState();
    const { name } = event.target;
    dispatch({
      type: SET_PROPERTY_OLD_VALUE,
      payload: propertyFields[name],
    });
  } catch (error) {
    dispatch(handleError(error));

    return 500;
  }
};

//	DESC: handle on field un-focus
export const onFieldUnFocus = (event) => async (dispatch, getState) => {
  const {
    MISC: {
      APP: {
        ROUTE: { verb },
      },
    },
  } = getState();
  if (verb === "add") {
    return;
  }
  try {
    const { name, dataset } = event.target;
    switch (name) {
      case "code":
      case "code_temp":
        await dispatch(
          triggerConfirmModal(
            `Changing the ${dataset.displayName} field will remove all existing file shares. Are you sure you want to proceed?`,
            name,
          ),
        );
        break;
      case "group_code":
      case "task_order":
        break;
      default:
        dispatch({ type: REMOVE_PROPERTY_OLD_VALUE });
        break;
    }
  } catch (error) {
    dispatch(handleError(error));

    return 500;
  }
};

export const submitProperty = (routeProps) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_PROPERTY_LOADING });

    //  Pull these object out of Redux state. We need to do an initial reformat data on first load
    //  Because data comeback from back were built before this.
    const {
      properties: { propertyFields },
      propertyContacts: { contacts },
      propertyAmenities: { amenities },
      propertyBudget: { BudgetData },
      propertyDisposition: { CommissionData },
    } = getState();

    //  task_order is important. Even though it should been caught over validation, We'll do it one more time here
    const { task_order } = propertyFields;
    if (!task_order) {
      throw new TypeError("Task Order is required");
    }

    //  budget_json has been sliced up on first load to render inside React Component.
    //  Backend is expecting the original format - therefore, budget_json will be adding back up as original
    const budget_json_merge = {
      ...BudgetData.INCOME,
      ...BudgetData["OPERATING EXPENSES"],
      ...BudgetData["RESOLUTION EXPENSES"],
    };

    const budget_json = Object.values(budget_json_merge).map((item) => {
      if (item.hasOwnProperty("code")) {
        return {
          ["Account Number"]: item.code,
          ["Account Name"]: item.description,
          ["Prior Expenditures"]: item.prior_expenditures,
          ["Budget Period Actuals"]: item.budget_period_actuals,
          ["Recurring Items"]: item.recurring_items,
          ["Non-Recurring Items"]: item.non_recurring_items,
          ["Notes"]: item.notes,
        };
      }
      return [];
    });

    //  amenities is expecting an array of ids on backend.
    //  This will filter out all the id === null
    const newAmenities = amenities.filter(({ amenity_id }) => amenity_id);

    // const marketingDescription = isJson(marketing_site_description)
    //     ? marketing_site_description
    //     : "[]";

    // const marketing_site_description_html = draftToHtml(
    //     JSON.parse(marketingDescription),
    //     // hashConfig,
    //     { trigger: "#", separator: " " },
    //     // directional,
    //     true,
    //     function() {}
    // );
    const response = await axios.put("/properties/edit/" + propertyFields.id, {
      ...propertyFields,
      contacts: Object.keys(contacts).reduce((object, key) => {
        object[contacts[key].id] = contacts[key].contact_id;
        return object;
      }, {}),
      // marketing_site_description_html,
      amenities: newAmenities,
      budget_json: JSON.stringify(budget_json),
      commissions_json: JSON.stringify([CommissionData]),
    });

    //  handleResponse will handle a potential errors come back from server
    //  it needs a response object to work correctly
    await dispatch(handleResponse(response));

    //  after handleResponse process response. We can assume that property is summited successfully
    //  socket "lives in helpers/bootstrap.js" will be use to send an event to Node runtime with a success status and a property id
    socket.emit("PROPERTY_STATUS", {
      status: true,
      id: propertyFields.id,
    });

    //  Dispatch a reload, this will get all the latest data from Property and update the module with those.
    await dispatch(getProperty(routeProps));

    dispatch(setAlert("Property Submitted", "success"));
  } catch (error) {
    dispatch(handleError(error));
  } finally {
    dispatch({ type: REMOVE_PROPERTY_LOADING });
  }
};

export const updateSearchColumn = (formValue) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_SEARCH_COLUMN,
      payload: formValue,
    });
  } catch (error) {
    dispatch(handleError(error));
  }
};

/**
 * @name updateSixPartFileTree
 * @param {String} sixPartFile
 * @description
 * Update Six Part File Tree when an action is finished
 * method is being used by uploadItem method inside file.js
 */

export const updateSixPartFileTree = (sixPartFile) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_PROPERTY_SIX_PART_FILE,
      payload: sixPartFile,
    });
  } catch (error) {
    dispatch(handleError(error));
  }
};

/**
 * @description Clear all Results and set the state back for defaults
 */

export const setUnmarketableFlag = () => async (dispatch, getState) => {
  try {
    const {
      properties: { propertyFields },
    } = getState();

    const {
      status_secondary,
      marketing_unmarketable_start_date,
      marketing_unmarketable_end_date,
    } = propertyFields;

    const newPropertyFields = { ...propertyFields };

    /**
     * code=1 (id=10), code=2 (id=11), code=4 (id=12), code=5 (id=14), code=6 (id=15) the Unmarketable flag needs to be "N" adding null to the list of N values makes it default to N
     */

    const nonMarketable = ["10", "11", "12", "14", "15"];

    let unmarketable;

    /*
		If status secondary is inclued in nonMarketable or not status_secondary and either
		no marketing start date or there is a marketing end date, Property will be consider non-marketable
		*/
    if (
      (nonMarketable.includes(status_secondary) || !status_secondary) &&
      (!marketing_unmarketable_start_date || marketing_unmarketable_end_date)
    ) {
      unmarketable = "N";
    } else {
      unmarketable = "Y";
    }

    dispatch({
      type: SET_PROPERTY_FIELDS,
      payload: {
        ...newPropertyFields,
        unmarketable,
      },
    });
  } catch (error) {
    dispatch(handleError(error));
  }
};

export const updateNetApprovedValue = () => async (dispatch, getState) => {
  try {
    const {
      properties: { propertyFields },
    } = getState();

    const { participation_percentage_owned, value_gross_approved } =
      propertyFields;

    let resultAmt = (
      (value_gross_approved || 0) *
      ((participation_percentage_owned || 0) / 100)
    ).toFixed(2);

    if (isNaN(resultAmt) || !isFinite(resultAmt)) {
      resultAmt = 0;
    }

    dispatch({
      type: SET_PROPERTY_FIELDS,
      payload: {
        ...propertyFields,
        value_net_approved_value: resultAmt,
      },
    });
  } catch (error) {
    dispatch(handleError(error));
  }
};

export const updateValueGrossBook = () => async (dispatch, getState) => {
  try {
    const {
      properties: { propertyFields },
    } = getState();

    const { participation_percentage_owned, value_gross_book } = propertyFields;

    let resultAmt = (
      (value_gross_book || 0) *
      ((participation_percentage_owned || 0) / 100)
    ).toFixed(2);

    if (isNaN(resultAmt) || !isFinite(resultAmt)) {
      resultAmt = 0;
    }

    dispatch({
      type: SET_PROPERTY_FIELDS,
      payload: {
        ...propertyFields,
        value_net_approved_value: resultAmt,
      },
    });
  } catch (error) {
    dispatch(handleError(error));
  }
};

export const calcPropertyOccupiedVacantSpace =
  () => async (dispatch, getState) => {
    const warnings = [];

    try {
      const {
        properties: { propertyFields },
      } = getState();

      const { property_management_leased_space, building_size } =
        propertyFields;
      const newPropertyFields = { ...propertyFields };

      let leasedSpace = parseFloat(property_management_leased_space) || 0;
      let buildingSize = parseFloat(building_size) || 0;
      let occupiedSpace = parseFloat(
        ((leasedSpace / buildingSize) * 100).toFixed(2),
      );
      if (leasedSpace > buildingSize) {
        warnings.push(
          `Leased Space can not be bigger than Building Area. Re-calculate to maximum allowed!`,
        );

        /* Set lease space equal to building size */
        newPropertyFields.property_management_leased_space = buildingSize;
        leasedSpace = buildingSize;

        /* give occuped max % of 100 */
        occupiedSpace = 100;
      }
      await dispatch({
        type: SET_PROPERTY_FIELDS,
        payload: {
          ...newPropertyFields,
          property_management_occupied_space: !isFinite(occupiedSpace)
            ? 0
            : occupiedSpace,
          property_management_vacant_space: buildingSize - leasedSpace,
        },
      });
    } catch (error) {
      dispatch(handleError(error));
    } finally {
      warnings.map((msg) => dispatch(setAlert(msg, "info")));
    }
  };
